import { render } from "./ProjectCard.vue?vue&type=template&id=1aa6cbec&scoped=true&lang=html"
import script from "./ProjectCard.vue?vue&type=script&lang=js"
export * from "./ProjectCard.vue?vue&type=script&lang=js"

import "./ProjectCard.vue?vue&type=style&index=0&id=1aa6cbec&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/sephendevos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa6cbec"]])

export default __exports__